import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import { deviceTypeEnum } from "../../../config/enum";

export default function DeviceGeneral({
  deviceNumber,
  setDeviceNumber,
  ghettoLastStep,
  setGhettoLastStep,
  year,
  setYear,
  numberOT,
  setNumberOT,
  deviceType,
  setDeviceType,
  adress,
  setAdress,
  edit,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={deviceNumber}
            onChange={(event) => setDeviceNumber(event.target.value)}
            variant="standard"
            type="text"
            label="Numéro de l'appareil"
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            value={year}
            onChange={(event) => setYear(event.target.value)}
            variant="standard"
            type="number"
            label="Année"
            InputProps={{
              inputProps: { min: 2005, max: parseInt(new Date().getFullYear() + 5) },
              maxLenght: 255,
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            value={numberOT}
            onChange={(event) => setNumberOT(event.target.value)}
            variant="standard"
            type="number"
            label="Numéro OT Binsa"
            inputProps={{ maxLength: 255 }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            value={adress}
            onChange={(event) => setAdress(event.target.value)}
            variant="standard"
            type="text"
            label="Adresse précise de l'appareil"
            inputProps={{ maxLength: 255 }}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            options={deviceTypeEnum}
            value={deviceType}
            onChange={(event, newDeviceType) => {
              setDeviceType(newDeviceType);
              if (newDeviceType !== null && newDeviceType.includes("Port")) {
                setGhettoLastStep(true);
              } else {
                setGhettoLastStep(false);
              }
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le type d'appareil" variant="standard" />
            )}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
